import Input from "../../../Medicine-master/Component/Input";

export const ProcedureInput = [
  {
    tag: Input,
    img: "",
    label: "Procedure Title",
    name: "procedureTitle",
    validation: "required",
    required: true,
    key: "procedureTitle",
  },
  {
    tag: Input,
    img: "",
    label: "Price",
    name: "price",
    validation: "required",
    key: "price",
  },
  {
    tag: Input,
    img: "",
    label: "CGST",
    name: "cgst",
    validation: "required",
    key: "cgst",
  },
  {
    tag: Input,
    img: "",
    label: "SGST",
    name: "sgst",
    validation: "required",
    key: "sgst",
  },
  {
    tag: Input,
    img: "",
    label: "Notes",
    name: "notes",
    // validation: "required",
    key: "notes",
  }
  ,
  {
    tag: Input,
    img: "",
    label: "Instructions",
    name: "instruction",
    // validation: "required",
    key: "instruction",
  }
];
